"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generatePaymentLink = void 0;
const payments_1 = require("../payments");
const getOrderById_1 = require("./getOrderById");
const generatePaymentLink = async (supabase, record, jose) => {
    // get the order from the order_id
    const order = await (0, getOrderById_1.getOrderById)(supabase, record.order_id);
    // if there is no value set or payment_provider_id then do nothing.
    if (!record.value && !record.payment_provider_id) {
        return new Response(JSON.stringify({ error: "No value or payment provider id" }), {
            headers: { "Content-Type": "application/json" },
            status: 400,
        });
    }
    // recalculate the value if the payment_provider_id is set
    if (record.payment_provider_id) {
        const payment_method = await (0, payments_1.getPaymentGatewayById)(supabase, record.payment_provider_id);
        const is_credit_card_provider = payment_method?.payment_types?.includes("Credit_Card");
        let fee_percentage = 0;
        if (is_credit_card_provider) {
            fee_percentage = order.agent?.config?.fees?.credit_card_fee ?? 0;
        }
        // calculate the total value of the order_line_ids[].amount_paid
        let total_value = 0;
        for (let i = 0; i < record.order_line_ids.length; i++) {
            const line = record.order_line_ids[i];
            total_value += line.amount_paid;
        }
        const fee = total_value * (fee_percentage / 100);
        await supabase
            .from("payment_requests")
            .update({
            value: total_value + fee,
        })
            .eq("id", record.id);
        return new Response(JSON.stringify({ success: true }), {
            headers: { "Content-Type": "application/json" },
        });
    }
    // IF THE VALUE IS NOT SET BUT THE PAYMENT_PROIVIDER IS SET THEN YOU NEED TO CALCULATE THE VALUE
    // THE VALUE IS THE TOTAL OF THE ORDER_LINE_ITEMS + THE PAYMENT_PROVIDER FEE
    // PAYEMNT PROVIDER FEE IS CHECKING IF THE PROVIDER IS A CREDIT_CARD PROVIDER AND THEN GETTING THE FEE FROM THE COUNTRY_PAYMENT_GATEWAY TABLE AND CALCULATING THE FEE
    // if the record exists already, return the link
    if (record.payment_link) {
        return new Response(JSON.stringify(record.payment_link), {
            headers: { "Content-Type": "application/json" },
        });
    }
    /*
     ###########################
       TO DO - GENERATE LINK BASED ON PAYMENT PROVIDER (E.G. 2C2P, STRIPE, ETC)
       CURRENTLY BELOW ONLY WORKS FOR 2C2P
     ###########################
     */
    // get the config and fee for the payment gateway
    const gateway = await (0, payments_1.getPaymentGatewayById)(supabase, record.payment_provider_id);
    const api_config = gateway.api_config.find((config) => {
        return config.env === "test";
    });
    if (!gateway) {
        throw new Error("No gateway found");
    }
    const data = {
        merchantID: api_config.merchant_id,
        invoiceNo: record.id,
        description: `Payment for ${order.reference}`,
        amount: record.value,
        userDefined1: `${record?.id}`,
        currencyCode: record.currency,
        tokenize: true,
        paymentChannel: ["CC"],
        uiParams: {
            userInfo: {
                name: order.client?.first_name + " " + order.client?.last_name,
                email: order.client?.email,
                mobileNo: order.client?.display_currency,
            },
        },
    };
    const alg = "HS256";
    const secret = new TextEncoder().encode(api_config.SHA_key);
    const signed_jwt = await new jose.SignJWT(data)
        .setProtectedHeader({ alg })
        .sign(secret);
    // sent POST request
    const response = await fetch("https://sandbox-pgw.2c2p.com/payment/4.1/paymentToken", {
        body: JSON.stringify({ payload: signed_jwt }),
        headers: {
            "Content-Type": "application/json",
        },
        method: "POST",
    });
    // if response is not ok, throw error
    if (!response.ok) {
        return new Response(JSON.stringify({ error: response.statusText }), {
            headers: { "Content-Type": "application/json" },
            status: 400,
        });
    }
    const pay_response = await response.json();
    const payload = jose.decodeJwt(pay_response.payload);
    const { webPaymentUrl } = payload;
    const { data: updatePaymentRequest, error: paymentRequestError } = await supabase
        .from("payment_requests")
        .update({
        payment_link: webPaymentUrl,
    })
        .eq("id", record.id);
    if (paymentRequestError) {
        throw new Error(paymentRequestError.message);
    }
};
exports.generatePaymentLink = generatePaymentLink;
